import React, { useEffect, useState } from 'react';
import "./PendingDiscountApproval.scss";
import { useHistory, useParams, useLocation } from 'react-router';
import moment from 'moment';
import { useSelector } from "react-redux";
import Button from "components/Button";
import { getDiscountPendingRaiseRequestsByID, updateDiscountPendingRaiseRequest } from 'core/services/api/mrdService';
import Toast from "components/Toast";
import { getInvoiceDetailsById } from 'core/services/api';
import { MocUserRole } from "core/services/models/Enums";

function PendingDiscountApproval() {
  const history = useHistory();
  const location = useLocation();

  console.log(location, "location");
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const [data, setData] = useState<any>();
  const [approvalStatusBefore, setApprovalStatusBefore] = useState<any>();
  const [discountData, setDiscountData] = useState<any>();
  const [displayToast, toggleDisplayToast] = useState<any>();
  const [pendingApprovalResult, setpendingApprovalResult] = useState<any>();
  const [comment, setComment] = useState<any>()
  const { invoiceId }: any = useParams();
  const { id }: any = useParams();
  console.log(id, "id in centre admin page")


  useEffect(() => {
    getInvoiceDetailsById(invoiceId)
      .then((res: any) => {
        console.log(res, "response");
        setData(res)
      })
      .catch((err: any) => console.log(err?.message))

    getDiscountPendingRaiseRequestsByID(id)
      .then((res: any) => {
        setDiscountData(res);
      })
      .catch((err: any) => console.log(err?.message))

  }, [])


  useEffect(() => {
    if (discountData) {
      const updatedData = discountData
      console.log(updatedData, "updated Data before in use Effect");
      if (updatedData) {
        setApprovalStatusBefore(updatedData);
      }
    }
  }, [discountData])

  useEffect(() => {
    if (discountData) {
      const currentData = discountData
      setComment(currentData?.comment);
    }
  }, [discountData])


  const approvalRequest = (() => {
    console.log(discountData, "discount Data");
    const updatedData = {
      ...discountData,
      comment: comment,
      approvalStatus: "APPROVED",
    };
    delete updatedData?.id;

    console.log(updatedData, "updated Data before");
    updateDiscountPendingRaiseRequest(id, updatedData).then((res: any) => {
      setpendingApprovalResult(res);
      setApprovalStatusBefore(res);
      console.log(updatedData, "updated Data after");
      toggleDisplayToast({ text: "Request has been approved successfully", type: "success" })

    }).catch((err: any) => {
      toggleDisplayToast({ text: "Request was not able to proceed", type: "error" })
    })

  })
  const cancelRequest = (() => {
    const updatedData = {
      ...discountData,
      approvalStatus: "REJECTED",
    };
    console.log(updatedData, "updated Data before");
    delete updatedData?.id
    updateDiscountPendingRaiseRequest(id, updatedData).then((res: any) => {
      setpendingApprovalResult(res);
      setApprovalStatusBefore(res);
      console.log(updatedData, "updated Data after");
      toggleDisplayToast({ text: "Request has been rejected successfully", type: "success" })

    }).catch((err: any) => {
      toggleDisplayToast({ text: "Request was not able to proceed", type: "error" })
    })
  })


  return (
    <div className='discount-wrapper'>
      <section className='section-wrapper'>
        <div className='top-heading-wrapper'>
          <div className='invoice-heading-container'>
            <div
              className="approval-back-image"
              onClick={() => {
                if (userDetail?.currentRole === MocUserRole.CONSULTANT || userDetail?.currentRole === MocUserRole.SYSTEM_ADMIN) {
                  history.push({
                    pathname: "/viewAllRequest",
                    state: {
                      tabValue: userDetail?.currentRole === MocUserRole.CONSULTANT ? 1 : 0,
                    },
                  })
                } else if (userDetail?.currentRole === MocUserRole.CENTER_ADMIN) {
                  history.push({
                    pathname: "/approvalRequests",
                  })
                } else {
                  history.goBack()
                }
              }}
            >
              <img
                src={"../../../../assets/images/back-icon.svg"}
                alt="back button"
                className="image-top-wrapper"
              />
            </div>
            <div className='Heading-Billing'>Invoice : {moment(data?.billedDate
            ).format("DD /MM/YYYY")}</div>
          </div>


        </div>
      </section>
      <section className='table-section'>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div className='patient-info'>
            <div className='patient-Heading'>Patient Name:</div>
            <div className='patient-Heading'> &nbsp; &nbsp;{data?.patientName}</div>
          </div>
          <div className='patient-info'>
            <div className='patient-Heading'>Patient Moc Id:</div>
            <div className='patient-Heading'> &nbsp; &nbsp;{data?.mocPatientId
            }</div>
          </div>
        </div>
        <table className="table">
          <thead style={{ backgroundColor: '#afc4ff' }}>
            <tr>
              <th>Treatments and Products</th>
              <th>SAC No</th>
              <th>Cost</th>
              <th>Discount</th>
              <th>Qty</th>
              <th>Total Tax Amount</th>
              <th>Charges</th>
            </tr>
          </thead>
          <tbody>

            {data?.invoiceItems.map((item: any, index: any) => (
              <tr key={index}>
                <td>{item?.treatmentAndDetails}</td>
                <td>{item?.sacNumber}</td>
                <th>{item?.cost}</th>
                <td>{item?.discount}</td>
                <td>{item?.quantity}</td>
                <td>{item?.totalTaxAmount}</td>
                <td>{item?.charges}</td>
              </tr>
            ))}

          </tbody>
        </table>
        <table style={{ marginLeft: '10px' }}>
          <tr style={{ color: "red" }} className='table-row'>
            <th className='table-header'>Discount {data?.discountType === "PERCENTAGE" ? "%" : ""}:</th>
            <td className='table-value'>&nbsp; &nbsp;{data?.discount}</td>
          </tr>
          <tr className='table-row'>
            <th className='table-header'>Pending Amount:</th>
            <td className='table-value'>&nbsp; &nbsp;{data?.pendingAmount?.toFixed(2)}</td>

          </tr>
          <tr>
            <th className='table-header'>Total Amount:</th>
            <td className='table-value'>&nbsp; &nbsp;{data?.totalAmount?.toFixed(2)}</td>

          </tr>
          <tr>
            <th className='table-header'>Total Amount Paid:</th>
            <td className='table-value'>&nbsp; &nbsp;{data?.totalAmountPaid?.toFixed(2)}</td>

          </tr>
          <tr>
            <th className='table-header'>Remarks:</th>
            <td className='table-value'>&nbsp; &nbsp;{data?.remarks}</td>

          </tr>
        </table>

        <div className='comment-wrapper'>
          <div className="comment-heading">Comment</div>
          <div className="textarea">
            <textarea
              name=""
              id=""
              value={comment}
              onChange={(e) =>
                setComment(e.target.value)
              }
              disabled={pendingApprovalResult?.approvalStatus === "REJECTED" || pendingApprovalResult?.approvalStatus === "APPROVED" ? true : false}
            />
          </div>
        </div>

      </section>
      <section className='button-section' style={{ marginBottom: '50px' }}>
        <Button
          text="Approve"
          type="submit"
          id="mrd-approve"
          onClick={approvalRequest}
          disabled={approvalStatusBefore?.approvalStatus !== "PENDING"}
        />

        <Button
          text="Reject"
          type="submit"
          outline={true}
          id="mrd-approve-submit"
          onClick={cancelRequest}
          disabled={approvalStatusBefore?.approvalStatus !== "PENDING"}
        />
      </section>
      {displayToast && (
        <Toast
          textMessage={displayToast?.text}
          type={displayToast?.type}
          onClose={() => {
            // toggleDisplayToast(false)
            if (userDetail?.currentRole === MocUserRole.CONSULTANT || userDetail?.currentRole === MocUserRole.SYSTEM_ADMIN) {
              history.push({
                pathname: "/viewAllRequest",
                state: {
                  tabValue: userDetail?.currentRole === MocUserRole.CONSULTANT ? 1 : 0,
                },
              })
            } else if (userDetail?.currentRole === MocUserRole.CENTER_ADMIN) {
              history.push({
                pathname: "/approvalRequests",
              })
            } else {
              history.goBack()
            }
          }}
          onCloseText="Close"
          onClickText={null}
        />
      )}
    </div >

  )
}

export default PendingDiscountApproval